import React from 'react'

//import styles from './Label.module.css'

const PoliceAVLLabel = ({
  ai: {
    attributes: { UnitID },
  },
}) => (
  <div>
    <div>{UnitID || '[BLANK]'}</div>
  </div>
)

export default PoliceAVLLabel
